var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLegalandcompliance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "69.000000pt",
    height: "73.000000pt",
    viewBox: "0 0 69.000000 73.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,73.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 720 c0 -5 7 -7 15 -4 19 8 19 14 0 14 -8 0 -15 -4 -15 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631 728 c2 -2 16 -14 32 -27 l27 -24 0 26 c0 24 -4 27 -32 27 -17 0 -29 -1 -27 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320 637 c0 -51 -13 -57 -127 -57 -57 0 -103 -4 -103 -9 0 -5 5 -11 12 -13 17 -6 -26 -199 -48 -215 -14 -10 -13 -15 9 -37 31 -31 99 -36 135 -10 22 15 30 44 13 44 -5 0 -19 44 -31 98 -12 53 -25 103 -27 110 -7 17 138 17 155 0 8 -8 12 -66 12 -195 l0 -183 -30 0 c-19 0 -34 -7 -42 -20 -9 -14 -24 -20 -50 -20 -21 0 -38 -4 -38 -10 0 -6 63 -10 170 -10 107 0 170 4 170 10 0 6 -17 10 -38 10 -26 0 -41 6 -50 20 -8 13 -23 20 -42 20 l-30 0 0 183 c0 129 4 187 12 195 17 17 162 17 155 0 -2 -7 -15 -57 -27 -110 -12 -54 -26 -98 -31 -98 -17 0 -9 -29 13 -44 36 -26 104 -21 135 10 22 22 23 27 9 37 -22 16 -65 209 -48 215 7 2 12 8 12 13 0 5 -46 9 -103 9 -114 0 -127 6 -127 57 0 18 -4 33 -10 33 -5 0 -10 -15 -10 -33z m-165 -194 c10 -43 20 -83 22 -90 4 -9 -8 -13 -41 -13 -25 0 -46 2 -46 5 0 11 43 175 45 175 2 0 11 -35 20 -77z m394 -10 c12 -45 21 -84 21 -87 0 -3 -21 -6 -46 -6 -33 0 -45 4 -41 13 2 7 12 47 22 90 9 43 19 77 20 75 2 -2 13 -40 24 -85z m-369 -123 c-8 -5 -28 -10 -45 -10 -16 0 -37 5 -45 10 -11 7 3 10 45 10 42 0 56 -3 45 -10z m390 0 c-8 -5 -28 -10 -45 -10 -16 0 -37 5 -45 10 -11 7 3 10 45 10 42 0 56 -3 45 -10z m-207 -177 c-18 -2 -48 -2 -65 0 -18 2 -4 4 32 4 36 0 50 -2 33 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675 10 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0 -8 -4 -11 -10z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegalandcompliance);
export default __webpack_public_path__ + "static/media/legalandcompliance.1462cf3b1e9008c577dc6d7378c67dcf.svg";
export { ForwardRef as ReactComponent };